function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermanentPressurePipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 397",
    cx: 16,
    cy: 16,
    r: 16,
    style: {
      fill: "#006cff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 431",
    d: "M642.18 498.143a14 14 0 1 1-14 14 14.016 14.016 0 0 1 14-14m0-2a16 16 0 1 0 16 16 16 16 0 0 0-16-16z",
    transform: "translate(-626.18 -496.143)",
    style: {
      fill: "#f5f5f5"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermanentPressurePipe);
export default __webpack_public_path__ + "static/media/permanent-pressure-pipe.72bae1fd44c0e6451283f38f3e2b71ec.svg";
export { ForwardRef as ReactComponent };